import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _category = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _createCategoryRequest = { category: '_category' };
var _createCategoryResponse = { category: '_category' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _getCategoryRequest = {};
var _getCategoryResponse = { category: '_category' };
var _queryCategoryRequest = {};
var _queryCategoryResponse = { categories: '_category' };
var _updateCategoryRequest = {
    mask: 'google.protobuf.FieldMask',
    category: '_category',
};
var _updateCategoryResponse = { category: '_category' };
function resolveWixCommentsCategoriesV1CommentsCategoriesUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/comments-categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/comments-categories/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/comments-categories/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/comments-categories/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/comments-categories/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/comments-categories/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/comments-categories/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/comments-categories',
                destPath: '/v1/categories',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/comments-categories',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/comments-categories/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/comments-categories',
                destPath: '/v1/categories',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/comments/v1/categories',
                destPath: '/v1/categories',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new category. */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.category',
            method: 'POST',
            methodFqn: 'wix.comments.categories.v1.CommentsCategories.CreateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCommentsCategoriesV1CommentsCategoriesUrl({
                protoPath: '/v1/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Retrieves a category by ID. */
export function getCategory(payload) {
    var _a = serializer(_getCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoryResponse, { _category: _category }).fromJSON;
    function __getCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.category',
            method: 'GET',
            methodFqn: 'wix.comments.categories.v1.CommentsCategories.GetCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCommentsCategoriesV1CommentsCategoriesUrl({
                protoPath: '/v1/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategory.fromReq = fromReq;
    __getCategory.__isAmbassador = true;
    return __getCategory;
}
/**
 * Updates a category.
 *
 * When you update `permissionsSettings`, existing comments remain visible even if they don't meet the updated permissions.
 *
 * Each time the category is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating the category.
 * This ensures you're working with the latest category and prevents unintended overwrites.
 */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.category',
            method: 'PATCH',
            methodFqn: 'wix.comments.categories.v1.CommentsCategories.UpdateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCommentsCategoriesV1CommentsCategoriesUrl({
                protoPath: '/v1/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/**
 * Deletes a category.
 *
 * > **Note:** If you delete a category, the comments in that category are no longer visible.
 */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.category',
            method: 'DELETE',
            methodFqn: 'wix.comments.categories.v1.CommentsCategories.DeleteCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCommentsCategoriesV1CommentsCategoriesUrl({
                protoPath: '/v1/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
/**
 * Retrieves a list of categories, with the specified paging, filtering, and sorting.
 *
 * See [Categories: Supported Filters and Sorting](https://dev.wix.com/docs/api-reference/crm/community/comments/categories/sort-and-filter)
 * for a complete list of supported filters and sorting options.
 *
 * To learn about working with _Query_ methods, see
 * [About the Wix API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language),
 * [About Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging),
 * and [About Field Projection](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-field-projection).
 */
export function queryCategory(payload) {
    var _a = serializer(_queryCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __queryCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v1.category',
            method: 'POST',
            methodFqn: 'wix.comments.categories.v1.CommentsCategories.QueryCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCommentsCategoriesV1CommentsCategoriesUrl({
                protoPath: '/v1/categories/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategory.fromReq = fromReq;
    __queryCategory.__isAmbassador = true;
    return __queryCategory;
}
//# sourceMappingURL=http.impl.js.map